import { Grid } from "@mui/material";
import { memo, Suspense } from "react";
import BusinessDataFormSection from "./components/business-data-form-section/BusinessDataFormSection";
import PriceDataFormSection from "./components/PriceDataFormSection";
import FeatureDateFormSection from "./components/FeatureDateFormSection";
import FeatureEnvironment from "./components/FeatureEnvironment";
import MxLoading from "@rf-l1/loading/MxLoading";
import GeneralInformationToUnits from "./components/GeneralInformationToUnits";
import SeoDataFormSection from "./components/seo-data-form-section/SeoDataFormSection";
import usePropertyHelpTypeLocations from "@rf/property/module/components/property-form/hooks/helps/usePropertyHelpTypeLocations";
import AlterEstate from "./components/AlterEstate";
import useUserHelp from "@rf-hooks/useUserHelp";
import usePropertyFormHelp from "../../../hooks/helps/usePropertyFormHelp";

const DescriptionStep = () => {
  const { isProject, isEdit } = usePropertyHelpTypeLocations();
  const { PROPERTY_STATUS } = usePropertyFormHelp();
  const { USER_HAS } = useUserHelp();

  const SHOW = {
    ALTER_ESTATE:
      !isProject && isEdit && USER_HAS.ALTER_ESTATE_TOKEN && PROPERTY_STATUS.ACTIVE
  };
  return (
    <Grid container spacing={2}>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        md={6}
        lg={8.5}
        alignContent="flex-start"
      >
        <Grid item xs={12}>
          <Suspense fallback={<MxLoading size={20} />}>
            <BusinessDataFormSection />
          </Suspense>
        </Grid>

        {isProject && (
          <Grid item xs={12}>
            <GeneralInformationToUnits />
          </Grid>
        )}

        {!isProject && (
          <Grid item xs={12}>
            <PriceDataFormSection />
          </Grid>
        )}
        {!isProject && (
          <Grid item xs={12}>
            <Suspense fallback={<MxLoading size={20} />}>
              <FeatureDateFormSection />
            </Suspense>
          </Grid>
        )}
        {!isProject && (
          <Grid item xs={12}>
            <Suspense fallback={<MxLoading size={20} />}>
              <FeatureEnvironment />
            </Suspense>
          </Grid>
        )}
        {SHOW.ALTER_ESTATE && (
          <Grid item xs={12} md={6} my={2}>
            <AlterEstate />
          </Grid>
        )}
      </Grid>
      <Grid container item xs={12} md={6} lg={3.5}>
        <Suspense fallback={<MxLoading size={20} />}>
          <SeoDataFormSection />
        </Suspense>
      </Grid>
    </Grid>
  );
};

export default memo(DescriptionStep);
